var _circle, _circle2, _ellipse, _path, _path2, _path3, _path4, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurprised(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 103,
    r: 80,
    fill: "#00FFFF",
    opacity: 0.45
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 97,
    r: 80,
    fill: "#FF00FF",
    opacity: 0.4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 101,
    rx: 79,
    ry: 80,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 76 Q76 70 86 76",
    fill: "none",
    stroke: "#CC00CC",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66 78 Q78 72 88 78",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114 80 Q126 72 138 78",
    fill: "none",
    stroke: "#CC00CC",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116 82 Q128 74 140 80",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77,
    cy: 100,
    rx: 16,
    ry: 16,
    fill: "#111"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77,
    cy: 100,
    rx: 16,
    ry: 16,
    fill: "none",
    stroke: "#CC00CC",
    strokeWidth: 3
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 103,
    rx: 16,
    ry: 16,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126,
    cy: 102,
    rx: 12,
    ry: 13,
    fill: "#111"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126,
    cy: 102,
    rx: 12,
    ry: 13,
    fill: "none",
    stroke: "#CC00CC",
    strokeWidth: 3
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 129,
    cy: 105,
    rx: 12,
    ry: 13,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 106,
    cy: 148,
    rx: 16,
    ry: 18,
    fill: "#111"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 106,
    cy: 148,
    rx: 16,
    ry: 18,
    fill: "none",
    stroke: "#CC00CC",
    strokeWidth: 3.5
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109,
    cy: 151,
    rx: 16,
    ry: 18,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurprised);
export default __webpack_public_path__ + "static/media/surprised.283ca2c76952d9a9941ed6e532d2c342.svg";
export { ForwardRef as ReactComponent };